'use client';

import { type CouponHeaderCardData, CouponHeaderCardLayout } from './CouponHeaderCardLayout';
import { OwnerSecondaryButton } from './OwnerSecondaryButton';

interface OwnerCouponHeaderCardProps {
  data: CouponHeaderCardData;
  onClickShop: () => void;
  onCopyLink: () => void;
  className?: string;
}

export const OwnerCouponHeaderCard = ({
  data,
  onClickShop,
  onCopyLink,
  className,
}: OwnerCouponHeaderCardProps) => (
  <CouponHeaderCardLayout
    data={data}
    showInfoIcon={data.status === 'EXPIRED'}
    onClickShop={onClickShop}
    secondaryButton={<OwnerSecondaryButton status={data.status} onCopyLink={onCopyLink} />}
    className={className}
  />
);
